import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root } from './InvoiceList.css';
import PageTitle from '../Layout/components/PageTitle';
import { Paper, Table, TableHead, TableRow, TableCell, TableBody, Button, InputBase, Dialog, Drawer, TableFooter, TablePagination, Tabs, Tab } from '@material-ui/core';
import Search from '@material-ui/icons/Search'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import SideList from './components/SideList'
import { BASE_URL } from '../../store/config';
import instance from '../../request/http';
import { roleStr, roleName } from '../../common/common';
import { timeFormat, toMoney } from '../../common/utils';
import AlertDialog from '../Layout/components/AlertDialog'
import Toast from '../Layout/components/Toast';
import InvoiceNormalList from '../InvoiceNormalList/InvoiceNormalList';
import InvoiceAdvanceList from '../InvoiceAdvanceList/InvoiceAdvanceList';

class InvoiceList extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            tabIndex: 0
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleCreateInvoice = this.handleCreateInvoice.bind(this);
    }
    render() {
        const {
            tabIndex
        } = this.state;
        const showTabPanel = () => {
            if (tabIndex === 0) {
                return <InvoiceNormalList></InvoiceNormalList>
            } else if (tabIndex === 1) {
                return <InvoiceAdvanceList></InvoiceAdvanceList>
            }
        }
        return (
            <Root>
                <div className="head h h-t">
                    <PageTitle title="All Invoice" subtitle="MANAGEMENT"></PageTitle>
                    <div className="f h h-r">
                        <Button className="btn" variant="contained" color="primary" onClick={this.handleCreateInvoice}>CREATE INVOICE</Button>
                    </div>
                </div>
                <Tabs
                    value={tabIndex}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={this.handleChange}
                    aria-label="disabled tabs example"
                    TabIndicatorProps={{ style: { display: "none" } }}
                >
                    <Tab className={tabIndex === 0 ? "tabSelect" : "tab"} label="Normal Invoice" />
                    <Tab className={tabIndex === 1 ? "tabSelect" : "tab"} label="Advance Invoice" />
                </Tabs>
                {showTabPanel()}
            </Root>
        );
    }
    componentDidMount() {
        const index = parseInt(localStorage.getItem('invoiceIndex'));
        const tabIndex = index ? index : 0;
        this.setState(() => ({
            tabIndex
        }))
    }
    handleChange(e, newValue) {
        let tabIndex = newValue;
        this.setState(() => ({
            tabIndex
        }))
        localStorage.setItem('invoiceIndex', tabIndex);
    }
    handleCreateInvoice() {
        this.props.history.push({ pathname: '/main/invoicecreate' });
    }
}

export default withRouter(InvoiceList);